import { Box } from "@mui/material";

import styles from "./MobileMenuToggler.module.scss";

export const MobileMenuToggler = (): JSX.Element => (
  <Box sx={{ display: { xs: "block", sm: "none" } }}>
    <button className={styles.toggler}>
      <span className={styles.hamburger}></span>
      <span className={styles.label}>Menu</span>
    </button>
  </Box>
);
